import { Link } from "react-router-dom";
import dayjs from 'dayjs';

export const useColumns = () => {
    return [
        {
            title: 'Email',
            dataIndex: 'email',
            key: 'email',
        },
        {
            title: 'Telefon',
            dataIndex: 'phone',
            key: 'phone',
        },
        {
            title: 'Tačni odgovori',
            dataIndex: 'correctAnswers',
            key: 'correctAnswers',
        },
        {
            title: 'Vreme trajanja',
            dataIndex: 'quizTime',
            key: 'quizTime',
            render: (time) => time ? `${time / 1000}s` : '-',
        },
        {
            title: 'Datum prijave',
            dataIndex: 'createdAt',
            key: 'createdAt',
            render: (date) => date ? dayjs(date).format('D MMM YYYY') : '-',
        },
        {
            title: 'Akcija',
            key: 'action',
            render: (_, record) => {
                const quizId = record.quizId;
                return (
                    <Link
                        to={`/quiz/${quizId}`}
                        className="btn btn-primary"
                        style={{ textDecoration: 'none', display: 'inline-block' }}
                    >
                        Pregled
                    </Link>
                );
            },
        },
    ];
};

